import { Box, Card,  List, ListItem,  Typography, Icon, IconButton } from '@mui/material';
import React, { useEffect,  useRef, useState } from 'react';
import MDButton from 'components/MDButton';
import EditIcon from 'common/customIcons/edit';
import DeleteIcon from 'common/customIcons/delete';
import SuperAdminIcon from 'common/customIcons/superAdmin';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router';

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { deleteRole, getRoleandPermission, getRoleandPermissionByID } from '../../redux/slices/roleAndPermissions';
import { closeCustomModalDialog, openCustomModalDialog, setModalLoader } from '../../redux/slices/modalSlice';
import { openSnackbar } from '../../redux/slices/common';
import NoDataFound from 'common/component/NoDataFound';
import { Riple } from 'react-loading-indicators';
const cardsConfig = [
    {
        key: "hwPermissions",
        label: "Hyperwolf Permissions",
        cardSx: {
            minWidth: "320px",
            borderRadius: 2.5,
            boxShadow: 'none',
            background: "rgba(255, 219, 30, 0.04)",
            padding: "24px",
            border: "1px solid #FFDB1E",
            mb: 2
        }
    },
    {
        key: "hempPermissions",
        label: "Hemp Permissions",
        cardSx: {
            minWidth: "320px",
            borderRadius: 2.5,
            boxShadow: 'none',
            background: "rgba(68, 126, 218, 0.04)",
            padding: "24px",
            border: "1px solid #0163FF",
            mb: 2
        }
    },
    {
        key: "stiloPermissions",
        label: "Stilo Permissions",
        cardSx: {
            minWidth: "320px",
            borderRadius: 2.5,
            boxShadow: 'none',
            background: "rgba(4, 195, 221, 0.04)",
            padding: "24px",
            border: "1px solid #04C3DD",
            mb: 2
        }
    },
   
    {
        key: "posPermissions",
        label: "POS Permissions",
        cardSx: {
            minWidth: "320px",
            borderRadius: 2.5,
            boxShadow: 'none',
            background: "rgba(46, 46, 58, 0.04)",
            padding: "24px",
            border: "1px solid #2E2E3A",
            mb: 2
        }
    },
    {
        key: "hyperdrivePermissions",
        label: "Hyperdrive Permissions",
        cardSx: {
            minWidth: "320px",
            borderRadius: 2.5,
            boxShadow: 'none',
            background: "rgba(46, 46, 58, 0.04)",
            padding: "24px",
            border: "1px solid #2E2E3A",
            mb: 2
        }
    },
];
export default function RolesPermissionsIndex({ canView, canCreate, canEdit, canDelete }) {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { isLoading: loading = false, roleData, loading: getLoding = false } = useSelector(state => state.roleAndPermissions);
    const [selectRoleData, setSelectRoleData] = useState("")
    const containerRef = useRef(null);

    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const getRolesName = () => {
        dispatch(getRoleandPermission())
    }
    const onMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - containerRef.current.offsetLeft);
        setScrollLeft(containerRef.current.scrollLeft);
    };

    const onMouseLeave = () => {
        setIsDragging(false);
    };

    const onMouseUp = () => {
        setIsDragging(false);
    };

    const onMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - containerRef.current.offsetLeft;
        const walk = (x - startX) * 1; // Multiply for sensitivity
        containerRef.current.scrollLeft = scrollLeft - walk;
    };
    useEffect(() => {
        getRolesName()
    }, [])
    const [formData, setFormData] = useState({
        "role": {
            "roleName": "",
            "roleIcon": ""
        },
        "platforms": {
            "hyperwolf": false,
            "hemp": false,
            "stilo": false,
            "hyperdrive": false
        },
        "permissions": {
            hwPermissions: [], stiloPermissions: [], hempPermissions: [], hyperdrivePermissions: [],posPermissions:[]
        }
    })

    const deleteHandler = (promotionId) => {
        dispatch(setModalLoader(true));
        dispatch(deleteRole(promotionId)).unwrap().then((res) => {
            showResponseMessage(res?.message, 'success');
            dispatch(closeCustomModalDialog());
            getRolesName()
        }).catch((err) => {
            dispatch(setModalLoader(false));
            showResponseMessage(err?.message, 'error');
        });
    };

    const showResponseMessage = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
        }
    };

    useEffect(() => {
        if (selectRoleData) {
            getRolesData()
        }
    }, [selectRoleData])

    const getRolesData = () => {
        dispatch(getRoleandPermissionByID(selectRoleData)).unwrap().then((res) => {
            const apiData = res

            const formattedData = {
                role: {
                    roleName: apiData.role?.roleName || "",
                    roleIcon: apiData.role?.roleIcon || ""
                },
                platforms: {
                    hyperwolf: apiData.platforms?.hyperwolf || false,
                    hemp: apiData.platforms?.hemp || false,
                    stilo: apiData.platforms?.stilo || false,
                    hyperdrive: apiData.platforms?.hyperdrive || false,
                    pos: apiData?.platforms?.pos || false
                },
                permissions: {
                    hwPermissions: apiData.permissions?.hwPermissions || [],
                    stiloPermissions: apiData.permissions?.stiloPermissions || [],
                    hempPermissions: apiData.permissions?.hempPermissions || [],
                    hyperdrivePermissions: apiData.permissions?.hyperdrivePermissions || [],
                    posPermissions: apiData?.permissions?.posPermissions || []
                }
            };
            setFormData(formattedData);
        }).catch((err) => {
            dispatch(setModalLoader(false));
            setFormData({
                "role": {
                    "roleName": "",
                    "roleIcon": ""
                },
                "platforms": {
                    "hyperwolf": false,
                    "hemp": false,
                    "stilo": false,
                    "hyperdrive": false,
                    "pos": false
                },
                "permissions": {
                    hwPermissions: [], stiloPermissions: [], hempPermissions: [], hyperdrivePermissions: [], posPermissions: []
                }
            });
        });
    }


    return (
        <Box>
            <Typography variant="h5" color="#9A9AAF" mb={3}>Roles and Permissions</Typography>
            <Box display="flex" alignItems="start" gap={3} className="discrepancy-batch-rep">
                <Card sx={{ minWidth: "285px", borderRadius: 2.5, boxShadow: 'none', backgroundColor: "#F5F5FF", padding: "24px 16px" }} className='tabs-card'>
                    <Box display="flex" justifyContent="space-between" alignItems="center" gap={0.5} mb={2.5}>
                        <Typography variant="body2" color="#656575">Account Roles</Typography>
                        {
                            canCreate &&
                            <MDButton
                                type='button'
                                color='primary'
                                sx={{ minWidth: '120px', fontSize: "14px", padding: "8px" }}
                                className="small-btn"
                                onClick={() => navigate('/roles-permissions/add-roles')}
                            >
                                <Icon>add</Icon>&nbsp;Add Roles
                            </MDButton>
                        }
                    </Box>
                    {
                        canView &&
                        <Box display="flex" flexDirection="column" gap={1.25}>
                            {
                                <>
                                    {roleData?.length === 0 ? <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", minHeight: "300px" }}><NoDataFound /></div> :
                                        roleData?.map((data) => {
                                            return (
                                                <Box
                                                    key={data?._id}
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    alignItems="center"
                                                    gap={0.5}
                                                    style={{
                                                        borderRadius: "10px",
                                                        border: "1px solid #F2F3F7",
                                                        padding: "10px",
                                                        cursor: "pointer"
                                                    }}

                                                    className={selectRoleData === data?._id ? "active" : ""}
                                                    onClick={() => setSelectRoleData(data?._id)}
                                                >
                                                    <Box display="flex" alignItems="center" gap={1}>
                                                        {data?.roleIcon ? (
                                                            <img
                                                                src={data.roleIcon}
                                                                alt={data.roleName}
                                                                style={{
                                                                    width: 18,
                                                                    height: 18,
                                                                    borderRadius: "50%",
                                                                    objectFit: "cover",
                                                                    background: '#eee'
                                                                }}
                                                            />
                                                        ) : (
                                                            <SuperAdminIcon style={{ marginRight: 8 }} />
                                                        )}
                                                        <Typography variant="body2" fontSize="12px" color="#2E2E3A" fontWeight="semibold">{data?.roleName}</Typography>
                                                    </Box>
                                                    <Box display="inline-flex" alignItems="center">
                                                        <IconButton disabled={!canEdit} color='primary' size='small' variant="primary" onClick={() => navigate(`/roles-permissions/edit-roles/${data?._id}`)} >
                                                            <EditIcon width='14px' height='14px' />
                                                        </IconButton>
                                                        <IconButton disabled={!canDelete} onClick={(e) => {
                                                            e.stopPropagation();
                                                            dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: data?._id }, modal: 'DELETE_MODAL' }));
                                                        }} color='error' size='small' variant="primary" sx={{ marginLeft: 0.5 }}>
                                                            <DeleteIcon width='14px' height='14px' />
                                                        </IconButton>
                                                    </Box>
                                                </Box>
                                            )
                                        })
                                    }</>
                            }
                        </Box>
                    }

                </Card>
                {
                    canView &&
                    <Box display="flex" alignItems="start" gap={3} minHeight="300px" style={{ marginRight: "-32px" }} className="card-box-rep">
                        {
                            selectRoleData ?
                                <> {
                                    getLoding ? <div className="riple-loader" style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", minHeight: "300px" }}>
                                        <Riple color='#3135cc' size='medium' text='' textColor='' />
                                    </div> :
                                    <Box
                                        ref={containerRef}
                                        className={`horizontal-scrolling-permission ${isDragging ? 'dragging' : ''}`}
                                        onMouseDown={onMouseDown}
                                        onMouseLeave={onMouseLeave}
                                        onMouseUp={onMouseUp}
                                        onMouseMove={onMouseMove}
                                        display="flex" alignItems="start" pb={1} overflow="auto" style={{ cursor: isDragging ? "grabbing" : "grab" }}
                                    >
                                        {cardsConfig.map(({ key, label, cardSx }) => {
                                            const platformPermissions = formData?.permissions[key];
                                            if (!platformPermissions || platformPermissions.length === 0) return null;
                                            return (
                                                <Card
                                                    key={key}
                                                    sx={cardSx}
                                                    style={{ minHeight: "300px", marginRight: "32px" }}
                                                >
                                                    <Box
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        alignItems="center"
                                                        gap={0.5}
                                                        pb={2.5}
                                                        mb={2.5}
                                                        style={{ borderBottom: "1px solid #D0D0DA" }}
                                                    >
                                                        <Typography variant="body2" color="#2E2E3A" fontWeight="600">
                                                            {label}
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        {platformPermissions.map((category, categoryIndex) => (
                                                            <Accordion key={category._id || categoryIndex} defaultExpanded>
                                                                <AccordionSummary
                                                                    expandIcon={<ExpandMoreIcon />}
                                                                    aria-controls={`${key}-${category.title}-content`}
                                                                    id={`${key}-${category.title}-header`}
                                                                >
                                                                    <Typography variant="body2" color="#2E2E3A" fontWeight="600">
                                                                        {category.title}
                                                                    </Typography>
                                                                </AccordionSummary>
                                                                <AccordionDetails>
                                                                    <List
                                                                        style={{
                                                                            display: "flex",
                                                                            gap: "5px",
                                                                            flexDirection: "column",
                                                                            paddingLeft: "20px"
                                                                        }}
                                                                        className='card-listing'
                                                                    >
                                                                        {(category.permissions || []).map((permission, permIndex) => (
                                                                            <ListItem key={permission._id || permIndex}>
                                                                                <Typography
                                                                                    variant="body2"
                                                                                    color="#656575"
                                                                                    fontSize="12px"
                                                                                    fontWeight="500"
                                                                                >
                                                                                    {permission.title}
                                                                                </Typography>
                                                                            </ListItem>
                                                                        ))}
                                                                    </List>
                                                                </AccordionDetails>
                                                            </Accordion>
                                                        ))}
                                                    </Box>
                                                </Card>
                                            );
                                        })}
                                    </Box>
                                }

                                </>
                                :
                                <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", minHeight: "300px" }}>
                                    <NoDataFound />
                                </div>
                        }
                    </Box>
                }
            </Box>
        </Box>
    );
}
